// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3eB3o","footer":"ModalFilter_footer__nRaEs"};